import styled from "styled-components";
import { SubHeading } from "../Step1Setup/styles";
import { GhostButtonComponent } from "../../../../CommonComponents/commonStyles";
import { PrimaryButtonComponent } from "../../../../CommonComponents/commonStyles";

export const ConfirmationMessage = styled.div`
  font-family: HelveticaNeue-Light;
  font-size: 24px;
  letter-spacing: 0.8px;
  color: #69923a;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 20px;
    letter-spacing: 0.67px;
    width: 273px;
  }
`;
export const AccountInformationWrapper = styled.div`
  display: flex;
`;

export const ConfirmationMessageStep2 = styled(ConfirmationMessage)`
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 40px;
    margin-bottom: 10px;
  }
`;

export const ContributeSubhead = styled.div`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  line-height: 1.5;
  color: #022737;
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const SubHeadSpace = styled(SubHeading)`
  margin-bottom: ${props => props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: ${props => props.mobileMarginBottom};
  }
`;

export const ButtonsWrap = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column-reverse;
    margin-bottom: 20px;
  }
`;

export const GhostButtonComponentStyles = styled(GhostButtonComponent)`
  min-width: 150px;
  margin-right: 30px;
  line-height: 1.67;
  letter-spacing: 0.5px;
  padding: 0 20px 0 20px;
  display: inline-block;
  width: auto;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: auto;
    font-size: ${props => props.theme.fontSize.heading};
    margin-right: 0;
  }
`;

export const PrimaryButtonComponentStyles = styled(PrimaryButtonComponent)`
  min-width: 150px;
  display: inline-block;
  padding: 0 20px 0 20px;
  border-radius: 0;
  line-height: 1.67;
  letter-spacing: 0.5px;
  border: none;
  width: auto;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: auto;
    font-size: ${props => props.theme.fontSize.heading};
    margin-bottom: 10px;
    margin-top: 20px;
  }
`;

export const ConfirmationMessageImage = styled.img`
  margin-right: 20px;
`;

export const ConfirmationMessageWrap = styled.div`
  display: flex;
  margin-bottom: 50px;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 38px;
  }
  p{
    margin-bottom: 0px;
  }
`;

export const Check = styled.div`
  display: ${props => props.displayType};
`;
